import type { Order } from "@/types/order";
import { ProductType } from "@/types/product";

export function isCall(order: Order): boolean {
  return [ProductType.shortCall, ProductType.longCall].includes(
    order.productType,
  );
}
